export function figureTraitsForId(traitsById, figureId) {
  return traitsById[String(figureId).padStart(3, '0')] || {};
}
